import React from "react";

import "css/SwitchInput.css";

const SwitchInput = ({ input, children, disabled }) => {
    return (
        <div className={"SwitchInput" + (disabled ? " disabled" : "")}>
            <div className="custom-switch-label">{children}</div>
            <div className="custom-switch">
                <input
                    className="custom-switch-input"
                    id={"custom-switch-" + input.name}
                    type="checkbox"
                    checked={input.value}
                    disabled={disabled}
                    {...input}
                />
                <label className="custom-switch-paddle" htmlFor={"custom-switch-" + input.name} />
            </div>
        </div>
    );
};

export default SwitchInput;



// WEBPACK FOOTER //
// ./src/components/SwitchInput.js